import { AppIcon } from '@tablesready/frontend-icons';
import { BillingVisibility } from '@tablesready/frontend-paid-feature-alert';

export interface NavigationItem {
  href: string;
  name: string;
  icon: AppIcon;
  pattern?: string;
  badgeRouteId?: string;
  visibility?: BillingVisibility;
}

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    href: '/waitlist',
    name: 'Waitlist',
    icon: AppIcon.waitlist,
    badgeRouteId: 'waitlist',
  },
  {
    href: '/reservations',
    name: 'Reservations',
    icon: AppIcon.reservations,
    badgeRouteId: 'reservations',
  },
  {
    href: '/floorplan',
    name: 'Floor Plan',
    icon: AppIcon.floorPlan,
    visibility: BillingVisibility.BUSINESS_PLAN_OUTSIDE_US,
  },
  {
    href: '/togo',
    name: 'To Go',
    icon: AppIcon.togo,
    visibility: BillingVisibility.BUSINESS_PLAN_OUTSIDE_US,
  },
  {
    href: '/history',
    name: 'Recent',
    icon: AppIcon.recent,
  },
  {
    href: '/analytics',
    name: 'Analytics',
    icon: AppIcon.analytics,
    visibility: BillingVisibility.STARTER_PLAN_OUTSIDE_US,
  },
  {
    href: '/customers',
    name: 'Customers',
    icon: AppIcon.customers,
  },
  {
    href: '/settings/preferences/notifications',
    name: 'Settings',
    icon: AppIcon.settings,
    pattern: '/settings',
  },
  {
    href: '/admin',
    name: 'Admin',
    icon: AppIcon.admin,
  },
];
